export const GET_ITEMS = 'GET_ITEMS';